module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAU0lEQVQokd3RMQqAMBBE0bfivZJWD6xtcrLYWAmChBTB7fczfyYgpa3puFrPgIDWuhgiAixd308Y33RKOeItyTw6QyAr5Lz3+dx1zNPJzyYess4FYzAbrn9PepQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/assets/04c.png
// module id = 1XV2
// module chunks = 64